import { Box, BoxProps } from '@modusign/design-system';

interface ContentBoxProps extends BoxProps<'div'> {}

export default function ContentBox(props: ContentBoxProps) {
  return (
    <Box
      bg="boxBackgroundNeutralBase"
      borderColor="boxBorderNeutralBase"
      borderStyle="solid"
      borderWidth="1px"
      p={6}
      {...props}
    />
  );
}
